import { render, staticRenderFns } from "./cobertura-capacitaciones.vue?vue&type=template&id=79d061d2&"
import script from "./cobertura-capacitaciones.vue?vue&type=script&lang=js&"
export * from "./cobertura-capacitaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports